export default {
  DAYS_LESS: 7,
  DAYS_LESS_YIELD: 30,
  DAYS_LESS_SUPERVISION: 5,
  DAYS_LESS_MAP: 0,
  MAPTILER_API_KEY: "import.meta.env.VITE_MAPTILER_API_KEY",
  MAPTILER_DATASET_ID: "57ce7daa-ea5b-4cd6-8975-32c41f5c5d90",
};


//"https://core.palmicultor.com.co/api/"
//http://localhost:7000/api/"